import React from "react";
import { ITeamWizards, TeamWizardsModeEnum } from "../../../../../types/teamWizards";
import TeamAssignmentWizard from "./team-assignment-wizard";
import JoinProjectWizard from "./join-project-wizard";
import TeamAssignmentGroupStatusesWizard from "./team-assignment-group-statuses-wizard";
import TeamMemberWithContextMenuWizard from "./team-member-with-context-menu-wizard";
import LeaveProjectWizard from "./leave-project-wizard";
import LeaveProjectGroupStatusesWizard from "./leave-project-group-statuses-wizard";
import OffboardTeamMemberWizard from "./offboard-team-member-wizard";
import OffboardTeamMemberGroupStatusesWizard from "./offboard-team-member-group-statuses-wizard";
import ProjectAdminAssignmentWizard from "./project-admin-assignment-wizard";
import RevokeProjectAdminRightsWizard from "./revoke-project-admin-rights-wizard";

const TeamWizards: React.FC<ITeamWizards> = (props) => {
    const { mode } = props;

    // TODO: Merge all group status components into one.    
    // Rendering the 'LeaveProjectGroupStatusesWizard' for joining

    return (
        <>
            {
                // Wizards
            }
            {mode === TeamWizardsModeEnum.TEAM_ASSIGNMENT_MODE && <TeamAssignmentWizard {...props} />}
            {mode === TeamWizardsModeEnum.JOIN_PROJECT_MODE && <JoinProjectWizard {...props} />}  
            {mode === TeamWizardsModeEnum.LEAVE_PROJECT_MODE && <LeaveProjectWizard {...props} />}
            {mode === TeamWizardsModeEnum.OFFBOARD_TEAM_MEMBER_MODE && <OffboardTeamMemberWizard {...props} />}
            {mode === TeamWizardsModeEnum.PROJECT_ADMIN_ASSIGNMENT_MODE && <ProjectAdminAssignmentWizard {...props} />}
            {mode === TeamWizardsModeEnum.REVOKE_PROJECT_ADMIN_RIGHTS_MODE && <RevokeProjectAdminRightsWizard {...props} />}

            {
                // Group statuses
            }
            {mode === TeamWizardsModeEnum.TEAM_MEMBER_DISPLAY_ITEMS_GROUP_STATUSES_MODE && <TeamAssignmentGroupStatusesWizard {...props} />}
            {mode === TeamWizardsModeEnum.PROJECT_ADMIN_ASSIGNMENT_GROUP_STATUSES_MODE && <TeamAssignmentGroupStatusesWizard {...props} />}
            {mode === TeamWizardsModeEnum.JOIN_PROJECT_GROUP_STATUSES_MODE && <TeamAssignmentGroupStatusesWizard {...props} />}            
            {mode === TeamWizardsModeEnum.LEAVE_PROJECT_GROUP_STATUSES_MODE && <LeaveProjectGroupStatusesWizard {...props} />}
            {mode === TeamWizardsModeEnum.REVOKE_PROJECT_ADMIN_RIGHTS_GROUP_STATUSES_MODE && <LeaveProjectGroupStatusesWizard {...props} />}
            {mode === TeamWizardsModeEnum.OFFBOARD_TEAM_MEMBER_GROUP_STATUSES_MODE && <OffboardTeamMemberGroupStatusesWizard {...props} />}            

            {
                // Team member
            }
            {mode === TeamWizardsModeEnum.TEAM_MEMBER_WITH_CONTEXT_MENU_MODE && <TeamMemberWithContextMenuWizard defaultOpenState={false} {...props} />}
        </>
    );
};

export default TeamWizards;
